import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    context: '',
};
export const breadcrumbSlice = createSlice({
    name: 'breadcrumb',
    initialState,
    reducers: {
        setBreadcrumbContext: (state, action) => {
            state.context = action.payload;
        },
        removeBreadcrumbContext: (state) => {
            state.context = '';
        },
    },
});
export const { setBreadcrumbContext, removeBreadcrumbContext } = breadcrumbSlice.actions;
export default breadcrumbSlice.reducer;
